export { CloudIconWithOverlay } from './components/CloudIconWithOverlay';
